import http from "@/settings/apiSettings"

class UsersDataService {
    get(): Promise<any> {
        return http.clientAuth.get("/AUTH_Users/GetUsers");
    }
    getRoluriUtilizatori(): Promise<any> {
        return http.clientAuth.get("/AUTH_RoluriUtilizatori/GetRoluriUtilizatori");
    }
    getAgenti(): Promise<any> {
        return http.clientComercialOdata.get(`/COM_Agenti`);
    }
}

export default new UsersDataService();
